import React, { useCallback, useEffect, useState } from 'react';
import { IonPage, IonContent, IonLoading } from '@ionic/react';
import { AppointmentStepProps } from '../../navigators/AppointmentNavigator';
import Stepper from '../../components/Stepper';
import AppHeader from '../../components/AppHeader';
import { connect } from 'react-redux';
import { setAppointment } from '../../store/actions/appointments';
import { AppointmentsRootState } from '../../store/reducers/appointments';
import { Appointment, Patient, User } from '../../models';
import LoginForm from '../../components/LoginForm';
import { Switch, Route } from 'react-router-dom';
import RegistrationForm from '../../components/RegistrationForm';
import { AuthenticationRootState } from '../../store/reducers/authentication';
import PatientRepository from '../../repositories/PatientRepository';
import EventBus from '../../services/EventBus';
import { useLoginCallback } from '../../hooks/msal.hooks';
import { login } from '../../store/actions/authentication';
import { AuthenticationParams } from '../../repositories/AuthenticationRepository';

const mapStateToProps = (
  state: {
    appointments: AppointmentsRootState;
    authentication: AuthenticationRootState;
  },
  ownProps: any
) => {
  return {
    appointment: state.appointments.appointment,
    sidep: state.appointments.sidep,
    user: state.authentication.user,
    isLoggedIn: !!state.authentication.accessToken
  };
};

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  login: (params: AuthenticationParams) => dispatch(login(params)),
  updateAppointment: (appointment: Partial<Appointment>) =>
    dispatch(setAppointment(appointment))
});

type RegisterProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

const Register: React.FC<AppointmentStepProps & RegisterProps> = ({
  step,
  history,
  nextStepRouterLink = '/',
  match,
  appointment,
  user,
  sidep,
  isLoggedIn,
  updateAppointment,
  login,
  stepperComponent = <Stepper step={step} />
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const onUserIsSet = useCallback(
    async (user: User) => {
      if (user) {
        if (appointment.patient && !appointment.patient.id) {
          const patient = await PatientRepository.create(
            new Patient({ ...appointment.patient, sidep })
          );

          updateAppointment({
            patient
          });

          history.push(nextStepRouterLink);
        } else if (user.patient) {
          if (sidep) {
            await PatientRepository.update(
              new Patient({ ...user.patient, sidep })
            );
          }

          updateAppointment({
            patient: user.patient
          });

          history.push(nextStepRouterLink);
        } else {
          EventBus.error('');
        }
      }
    },
    [appointment.patient, history, nextStepRouterLink, sidep, updateAppointment]
  );

  useEffect(() => {
    if (
      isLoggedIn &&
      user &&
      Object.entries(appointment).length !== 0 &&
      !appointment.patient
    ) {
      onUserIsSet(user);
    }
  }, [appointment, appointment.patient, isLoggedIn, onUserIsSet, user]);

  const handleLogin = useLoginCallback();
  const handleSubmit = () => {
    setIsLoading(true);
    handleLogin();
  };

  return (
    <IonPage>
      <IonLoading isOpen={isLoading} />
      <AppHeader />
      {stepperComponent}
      <IonContent>
        <Switch>
          <Route path={match.url} exact>
            <div className="ion-padding wrapper wrapper--stretch wrapper--centered">
              <h2 className="ion-text-center">S'identifier</h2>
              <LoginForm
                onSubmit={handleSubmit}
                registerRouterLink={`${match.url.replace(
                  /\/$/,
                  ''
                )}/inscription`}
              />
            </div>
          </Route>
          <Route path={`${match.url}/inscription`} exact>
            <div className="ion-padding wrapper">
              <h2 className="ion-text-center">Inscription</h2>
              <RegistrationForm
                onSubmit={() => setIsLoading(true)}
                onRegisterSuccess={async (user: User) => {
                  await onUserIsSet(user);
                  setIsLoading(false);
                }}
                onRegisterError={() => {
                  setIsLoading(false);
                }}
                loginRouterLink={`${match.url}`}
              />
            </div>
          </Route>
        </Switch>
      </IonContent>
    </IonPage>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
